// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PaymentTerms.yaml
// Generated: 2026-03-26T16:26:04.092Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePaymentTerms, UpdatePaymentTerms, PaymentTerms } from '@/types/core/PaymentTerms';

/**
 * PaymentTerms Service
 * CRUD operations for PaymentTerms via the ABP API.
 */
export const paymentTermsService = new EntityService<PaymentTerms, CreatePaymentTerms, UpdatePaymentTerms>(
  '/api/core/paymentterms',
  'PaymentTerms',
);
